import React from 'react';
import { useTranslation } from 'react-i18next';
import { usePageTransition, TextReveal, SUNSARI_LOGO_URL } from '../PageTransition';
import { NepaleseFrame } from './WoodenFrames';

const PhilosophySection = () => {
  const { t } = useTranslation();
  const { navigateWithTransition } = usePageTransition();
  const { motion } = require('framer-motion');

  return (
    <section className="relative py-24 md:py-32 bg-[#F5F3EF]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="text-center mb-16">
          <motion.div className="mb-8" initial={{ opacity: 0, scale: 0.8 }} whileInView={{ opacity: 1, scale: 1 }} viewport={{ once: true }} transition={{ duration: 0.8 }}>
            <img src={SUNSARI_LOGO_URL} alt="Sunsari Logo" className="h-24 md:h-32 lg:h-40 w-auto mx-auto" data-testid="philosophy-logo" />
          </motion.div>
          <TextReveal><p className="text-[#6B705C] text-xs tracking-[0.3em] uppercase mb-4">{t('philosophy.subtitle')}</p></TextReveal>
          <TextReveal delay={0.1}>
            <h2 className="text-4xl md:text-5xl lg:text-6xl text-[#2F2F2F]" style={{ fontFamily: "'DM Serif Display', Georgia, serif" }}>
              {t('philosophy.title').split(' ').map((word, i) => 
                word === 'tradition' || word === 'perinteet' ? <span key={i}><span className="italic">{word}</span> </span> : <span key={i}>{word} </span>
              )}
            </h2>
          </TextReveal>
        </div>

        <div className="grid md:grid-cols-2 gap-12 md:gap-16 items-center">
          <NepaleseFrame src="https://customer-assets.emergentagent.com/job_87e498ce-d096-43cf-96be-abf06e8008e0/artifacts/elwprcp7_Messenger_creation_1424992914294593.jpeg" alt="Restaurant Interior" className="max-w-md mx-auto" />
          <div className="space-y-6">
            <TextReveal><p className="text-[#6B705C] text-xs tracking-[0.3em] uppercase">{t('philosophy.experience')}</p></TextReveal>
            <TextReveal delay={0.1}>
              <h3 className="text-3xl md:text-4xl text-[#2F2F2F]" style={{ fontFamily: "'DM Serif Display', Georgia, serif" }}>
                {t('philosophy.culinaryJourney').split(' ').map((word, i) => 
                  word === 'Journey' || word === 'matka' || word === 'resa' ? <span key={i}><span className="italic">{word}</span> </span> : <span key={i}>{word} </span>
                )}
              </h3>
            </TextReveal>
            <TextReveal delay={0.2}><p className="text-[#6B705C] font-light leading-relaxed">{t('philosophy.description')}</p></TextReveal>
            <TextReveal delay={0.3}>
              <motion.button onClick={() => navigateWithTransition('/about')}
                className="text-[#2F2F2F] text-sm tracking-[0.15em] uppercase border-b border-[#2F2F2F] pb-1 hover:text-[#C97A2B] hover:border-[#C97A2B] transition-colors duration-300"
                whileHover={{ x: 10 }} data-cursor-hover>
                {t('philosophy.discoverMore')} →
              </motion.button>
            </TextReveal>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PhilosophySection;
